import React from 'react';
import PropTypes from 'prop-types';

import { InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';

import { CurrentTheme, MagstimDropdown } from "common";
import MagstimInputGroup from './MagstimInputGroup'

class MagstimInputGroupDropDownWithCheckBox extends MagstimInputGroup {

    onCheckboxChange = () => {
        const newCheckState = !this.state.checked;
        this.setState({checked:newCheckState, disabled:!newCheckState})

        if(this.props.onSetEnabled !== undefined){
            this.props.onSetEnabled(this.props.name, newCheckState);
        }
    }

    render() {

        var titleClassName = "input-group-highlight"

        if(this.state.disabled === true){
            titleClassName = "input-group-disabled"
        }

        return(
            <>
            <InputGroupAddon addonType="prepend" className="d-md-none d-lg-none prepend-mobile">
                <InputGroupText className={titleClassName}>{this.props.title}</InputGroupText>
            </InputGroupAddon>

            <InputGroup size={CurrentTheme().ControlSize}>
                <InputGroupAddon addonType="prepend" className="d-none d-md-block">
                    <InputGroupText className={titleClassName}>{this.props.title}</InputGroupText>
                </InputGroupAddon>
                <InputGroupAddon addonType="append" className="magstim-checkbox-container mr-3">
                        <Input type="checkbox" className="magstim-checkbox" checked={this.state.checked} onChange={this.onCheckboxChange}/>
                </InputGroupAddon> 
                <MagstimDropdown size={CurrentTheme().ControlSize} ref={this.props.dropDownRef} disabled={this.state.disabled}>
                    {this.props.options.map(option => (
                        this.dropdownItem(option, this.props.default)
                    ))}
                </MagstimDropdown>
             
            </InputGroup>
            </>
        );
    }
}

MagstimInputGroupDropDownWithCheckBox.propTypes = {
    title: PropTypes.string,
    options:PropTypes.array,
    default:PropTypes.string,
    dropDownRef:PropTypes.object,
    disabled:PropTypes.bool,
    checked:PropTypes.bool,
    onSetEnabled:PropTypes.func
};

MagstimInputGroupDropDownWithCheckBox.defaultProps = {
    title: "",
    options:[],
    default:"",
    dropDownRef:undefined,
    disabled:false,
    checked:undefined,
    onSetEnabled:undefined
};

export default MagstimInputGroupDropDownWithCheckBox